module.exports = __webpack_public_path__ + "img/3.63719fc2.jpg";